<template>
<div id="mainDiv">

    <nav class="navbar navbar-expand-lg navbar-light" v-if="$route.name !== 'epicFury'">
        <div class="navBarTitle row align-items-center">
            <div class="col-2 d-flex justify-content-center align-items-center">
                <img src="../static/img/arrowsSmall.png" alt="" class="arrowSmall">
            </div>
            <div @click="goToHomePage" class="col-5 fw-bold pe-0 d-flex align-items-center">סיור מוזיאון</div>
            <div class="col-3 ps-0 d-flex justify-content-center align-items-center" @click="goToHomePage">
                <img src="../static/img/logoEDMv2.png" alt="" style="width: 80px; object-fit: contain;" />
            </div>
            <div class="col-2 d-flex justify-content-start align-items-center">
                <div style="text-align: left; color: black;" @click="showMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                    </svg>
                </div>
            </div>

        </div>

    </nav>
    <div :style="$route.name === 'epicFury'
        ? 'min-height: 100vh; text-align: right; max-width: 590px; width: 100%;'
        : 'min-height: calc(100vh - 56px); text-align: right; max-width: 590px; width: 100%;'">
        <router-view></router-view>
    </div>

    <div class="menu " ref="openMenu">
        <img src="../static/img/cross.png" alt="" class="cross" @click="hideMenu" />
        <div style="height: 15%; color: white;" class="d-flex justify-content-center align-items-center">
            <img src="../static/img/logoWhite.png" alt="" style="width: 97px; position: relative;" />
        </div>
        <Accordion />
    </div>
</div>
</template>
<!-- Google Analytics scripts moved to public/index.html -->
<script>
import Accordion from "@/components/accordion";

export default {
    components: {
        Accordion,
    },
    data() {
        return {
            title: "מוזיאון עין דור",
            isMenuOpen: false
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
    },
    methods: {
               goToHomePage() {
            this.$router.push("/");
        },
        showMenu() {
                this.$refs.openMenu.classList.add('showMenu');
        },
        hideMenu() {
            this.$refs.openMenu.classList.remove('showMenu')
        },
    },
    name: "App",
};
</script>

<style>
.showMenu {
    top: 0px !important;
  opacity: 1;

}


.cross {
    width: 33px;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 5;
}

.menu {
    /* width: 100%;
    height: 100vh;
    background: black;
    position: fixed;
    bottom: 250vh;
    left: 0px;
    font-family: 'segoeui';
    font-size: 25px;
    font-weight: bold;
    opacity: 1; */
    width: 100%;
    height: 230vh;
    background: black;
    position: absolute;
    bottom: 250vh;
    /* top: 0px; */
    left: 0px;
    font-family: 'segoeui';
    font-size: 25px;
    font-weight: bold;
}

.arrowSmall {
    height: 32px;
}

@font-face {
    font-family: rubik;
    src: url(../static/Rubik/Rubik-Black.ttf);
}

@font-face {
    font-family: segoeui;
    src: url(../static/segoeui/segoeui.ttf);
}

.navBarTitle {
    position: relative;
    font-size: 25px !important;
    color: white;
    text-align: right;
    width: 100%;
    background-color: #63C4C3;
    font-family: 'segoeui' !important;
    height: 80px;
    margin: 0px !important;
}

.navbar {
    padding: 0px !important;
}

#mainDiv {
    /* background-image: url("../static/img/backgroundApplication.jpg") !important; */
    position: relative;
    transform: translateZ(0);
    direction: rtl;
    font-family: segoeui;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    max-width: 590px;
    margin: 0 auto;
}

/* #mainDiv::after {
  content: "";
  opacity: 0.6;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: -1;
} */
#app {
    color: #212529;
    font-family: "Assistant", sans-serif;
}

.rtl {
    direction: rtl;
}

@media (min-width: 992px) {
    .navbar-expand-lg {
        -ms-flex-flow: wrap !important;
        flex-flow: wrap !important;
    }
}

@media screen and (max-width: 600px) {}
</style>
